import * as React from 'react';
import { Rule, RulesMessages, ValidationResponse } from '../utils/validator';
import { HatType } from './Hat';
import '../css/input-cvv.sass';
import NumericInput from './NumericInput';

interface CVVInputProps {
  placeHolder?: string;
  name: string;
  value?: string;
  id: string;
  label?: string;
  required?: boolean;
  hasError: boolean;
  errors?: any;
  theme?: 'night' | 'day';
  validationRules?: Rule[];
  rulesMessages?: RulesMessages;
  onChange?: Function;
  onComplete?: Function;
  onError?: Function;
  onBlur?: Function;
  onEsc?: Function;
  onEnter?: Function;
  onLeft?: Function;
  onRight?: Function;
  onUp?: Function;
  onDown?: Function;
  onSpace?: Function;
  hat?: HatType[];
  readOnly?: boolean;
  disabled?: boolean;
  toolTip?: React.ReactNode;
}

interface CVVInputState {
  inputValue: string;
  validationResponse?: ValidationResponse;
}

export default function CVVInput(props: CVVInputProps) {
  const [state, setState] = React.useState<CVVInputState>({
    inputValue: props.value || ''
  });

  const { label = 'CVV' } = props;

  const componentPropsRules: Rule[] = [];
  componentPropsRules.push({
    ruleName: 'cvv',
    message: props.rulesMessages && props.rulesMessages.cvv,
    defaultMessage: `${label} is not a valid.`,
    dependsOn: ['minLength']
  });
  React.useEffect(() => {
    setState({ ...state, inputValue: props.value || '' });
  }, [props.value]);

  return (
    <>
      <NumericInput
        {...props}
        value={state.inputValue}
        label={label}
        validationRules={componentPropsRules}
        minLength={3}
        maxLength={4}
        onBlur={(e: any) => {
          if (props.onBlur !== undefined) {
            props.onBlur(e.target.value);
          }
        }}
        onChange={props.onChange}
        toolTip={props.toolTip}
      />
    </>
  );
}
